import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["marker"]
  static values = { storageKey: String, entry: Boolean, used: Boolean }

  connect() {
    if (this.entryValue) sessionStorage.removeItem(this.storageKeyValue)
    if (this.usedValue) sessionStorage.setItem(this.storageKeyValue, "1")
    if (sessionStorage.getItem(this.storageKeyValue)) this.markerTarget.value = ""
  }
}
